import API from "../../service/api"

/**
 * Group content class
 */
class Group extends API{
    /**
     * 创建群吧
     * 类型1,0 1-公开；0-非公开
     */

    async group_register(name,tagID,description,is_private){
        return await this.sendget("group/passport/group_register/?name="+name+"&tagID="+tagID+"&description="+description+"&is_private="+is_private);
    }

    /**
     *
     * @param Number 删除
     *          $groupinfoID :群吧groupinfoID
     */
    async group_remove(groupinfoID){
        return await this.sendget("group/passport/group_remove/?groupinfoID="+groupinfoID);
    }
    /**
     *
     * @param Number 群吧更新
     * 群吧字段名 name,description,background,is_private(1,0)
     */
    async  group_update(groupinfoID, field, value){
        return await this.sendget("group/passport/group_remove/?groupinfoID="+groupinfoID+"&field="+field+"&value="+value);
    }
    /**
     * 群吧跟新
     */
    //
    // async group_register(name,description,is_private){
    //     return await this.sendget("group/user/group_update/?name="+name+"&description="+description+"&is_private="+is_private);
    // }


    /**
     * 群吧 我创建的群吧 列表（登录用户）
     *
     * @param number
     *          $id  no
     * @param number
     *          $lastID no
     */
    async group_list(){
        return await this.sendget("group/user/group_list/");
    }
    /**
     * 我加入的群吧列表（登录用户）
     *
     */
    async group_join_list(){
        return await this.sendget("group/user/group_join_list/");
    }
    /**
     * 群吧成员
     * 获取 group member 列表
     */
    async group_view_member(groupinfoID, lastID){
        return await this.sendget("group/page/group_view_member/?groupinfoID="+groupinfoID+"&lastID="+lastID);
    }
    /**
     * 群吧成员申请 （群主可见）
     */
    async member_apply(groupinfoID){
        return await this.sendget("group/user/member_apply/?groupinfoID="+groupinfoID);
    }
    /**
     * 群吧认领管理员 
     */
    async group_apply_manager(groupinfoID){
        return await this.sendget("group/user/group_apply_manager/?groupinfoID="+groupinfoID);
    }
    /**
     * 群吧认领管理员列表 （admin主可见）
     */
    async apply_user_list(lastID){
        return await this.sendget("group/admin/apply_user_list/?lastID="+lastID);
    }
    /**
     *
     * 申请人批准
     */
    async apply_user_add(groupinfoID, userID){
        return await this.sendget("group/admin/apply_user_add/?groupinfoID="+groupinfoID+"&userID="+userID);
    }
    /**
     *
     * 申请人拒绝
     */
    async apply_user_delete(groupinfoID, userID){
        return await this.sendget("group/admin/apply_user_delete/?groupinfoID="+groupinfoID+"&userID="+userID);
    }
    /**
     *
     * 群吧成员状态更新 （群主可见）
     */
    async member_update(groupinfoID, userID, status){
        return await this.sendget("group/user/member_update/?groupinfoID="+groupinfoID+"&userID="+userID+'&status='+status);
    }
    /**
     * 群吧成员删除 （群主可见）
     */
    async member_remove(groupinfoID, userID){
        return await this.sendget("group/user/member_remove/?groupinfoID="+groupinfoID+"&userID="+userID);
    }
    /**
     * 群吧顶部信息条
     */
    async group_view_bar(groupinfoID){
        return await this.sendget("group/page/group_view_bar/?groupinfoID="+groupinfoID);
    }
    /**
     * 认领主
     */
    async group_claim(groupinfoID){
        return await this.sendget("group/user/group_claim/?groupinfoID="+groupinfoID);
    }
    /**
     * 激活
     */
    async group_activate(groupinfoID){
        return await this.sendget("group/user/group_activate/?groupinfoID="+groupinfoID);
    }
    /**
     * 群吧首页-群吧详细信息
     */
    async group_view(groupinfoID){
        return await this.sendget("group/page/group_view/?groupinfoID="+groupinfoID);
    }
    /**
     * 返回推荐群吧列表 群吧推广帖
     */
    async group_view_article(groupinfoID, lastID){
        return await this.sendget("group/page/group_view_article/?groupinfoID="+groupinfoID+"&lastID="+lastID);
    }
    /**
     * 返回分类标签（分类）
     */
    async group_tag(){
        return await this.sendget("group/page/group_tag/");
    }

    /**
     * 某分类下的返回热门群组
     */
    async hot_group(tagID,lastID){
        return await this.sendget("group/page/hot_group/?tagID="+tagID+"&lastID="+lastID);
    }
    /**
     * 某分类下的返回新群组
     */
    async new_group(tagID,lastID){
        return await this.sendget("group/page/new_group/?tagID="+tagID+"&lastID="+lastID);
    }

    /**
     * 分类群组下的最新文章 推广贴（分类）
     */
    // async new_article(tagID){
    //     return await this.sendget("group/page/new_article/?tagID="+tagID);
    // }
    /**
     * 分类群组下的最热文章 推广贴（分类）
     */
    async new_article(tagID,lastID){
        return await this.sendget("group/page/new_article/?tagID="+tagID+"&lastID="+lastID);
    }
    /**
     * 分类群组下的最热文章 推广贴（分类）
     */
    async hot_article(tagID,lastID){
        return await this.sendget("group/page/hot_article/?tagID="+tagID+"&lastID="+lastID);
    }
    /**
     * 返回热门帖子列表
     */
    // async hot_article_list(lastID){
    //     return await this.sendget("group/page/hot_article_list/?lastID="+lastID);
    // }
    /**
     * 关注列表
     */
    async group_join_article_list(lastID){
        return await this.sendget("group/user/group_join_article_list/?lastID="+lastID);
    }
    /**
     * 群吧文章列表页
     */
    async article_list(groupinfoID, topicID, lastID){
        return await this.sendget("group/page/article_list/?groupinfoID="+groupinfoID+"&topicID="+topicID+'&lastID='+lastID);
    }
    /**
     * 热榜页 热榜列表
     */
    // async hot_article_list(){
    //     return await this.sendget("group/page/article_list/?groupinfoID="+groupinfoID);
    // }
    // async hot_article_list(lastID){
    //     return await this.sendget("group/page/hot_article/");
    // }
    /**
     * 个人首页 群贴列表
     */
    async article_list_my(userID,lastID){
        return await this.sendget("group/page/article_list_my/?userID="+userID+"&lastID="+lastID);
        //return await this.sendget(`group/page/article_list_my/?userID={userID}&lastID={lastID}`);
    }
    /**
     * 热门群吧
     */
    async recommand_group(lastID){
        let res = await this.sendget("group/page/recommand_group/?lastID="+lastID);
        if(res.status){
            for(var item in res.data){
                res.data[item].groupID = res.data[item].id
            }
            res.data = Object.values(res.data);
            // res.data.data.forEach(item=>{
            // 	item.bloggerID = item.id
            // })
        }
        return res
    }
    /**
     * 邀请人加入群吧
     */
    async group_invite(groupinfoID, userID){
        return await this.sendget("group/user/group_invite/?groupinfoID="+groupinfoID+"&userID="+userID);
    }
    /**
     * 修改文章
     */
    async article_update(data){
        return await this.sendpost('article/user/article_update/',data)
    }
    /**
     * 删除文集中的已发布文章
     *
     * @param {文章的postID}
     *          postID
     * @param {visible=0 为删除} visible
     */
    async article_delete(postID,visible){
        return await this.sendget('article/user/article_delete/?postID='+postID+'&visible='+visible)
    }

    /**
     * 删除群吧中的已发布文章
     *
     * @param {文章的postID}
     *          postID
     * @param {visible=0 为删除} visible
     */
    async article_delete(postID,visible){
        return await this.sendget('article/user/article_delete/?postID='+postID+'&visible='+visible)
    }
    /**
     置顶
     */
    async article_sticky(postID){
        return await this.sendget('article/user/article_sticky/?postID='+postID);
    }
    /**
     待定
     */
    /**
     * 返回一个第一级的评论
     *
     * @param number
     *          id
     */
    async article_view_comment_one(id){
        return await this.sendget("blog/page/article_view_comment_one/?id="+id);
    }

    /**
     * 返回正文页评论
     *
     * @param number
     *          id
     */
    async article_view_comment(id,lastID){
        return await this.sendget("blog/page/article_view_comment/?id="+id+"&lastID="+lastID);
    }

    /**
     * 发表/回复评论
     *
     * @param obj
     *          article_data | post
     *          对象{'msgbody'=>"回复内容",'postID'=>144819,"typeID"=>1,}
     */
    async reply_add(obj){
        return await this.sendpost("article/user/reply_add/",obj);
    }

    /**
     * 删除评论
     *
     * @param postID
     *          评论的postID
     */
    async reply_delete(postID){
        return await this.sendget("article/user/reply_delete/?id="+postID);
    }

    /**
     * 返回文章的 likes
     * @param {number} id
     * @returns
     */
    async article_buzz_list(id){
        return await this.sendget("article/page/article_buzz_list/?id="+id);
    }
    /**
     * 点赞
     *
     * @param number
     *          postID
     */
    async buzz_add(postID){
        return await this.sendget("account/user/buzz_add/?postID="+postID);
    }

    /**
     * 取消点赞
     *
     * @param postID
     *          $postID
     */
    async buzz_delete(postID){
        return await this.sendget("account/user/buzz_delete/?postID="+postID);
    }

    /**
     * 收藏、加书签
     *
     * @param postID
     *          $postID
     */
    async bookmark_add(postID){
        return await this.sendget("account/user/bookmark_add/?postID="+postID);
    }

    /**
     * 取消收藏、取消书签
     *
     * @param postID
     *          $postID
     */
    async bookmark_delete(postID){
        return await this.sendget("account/user/bookmark_delete/?postID="+postID);
    }



    async sendget(url){
        try{
            let rs = await this.get(url);
            return rs;
        }
        catch(e){
            console.log(e)
            return false;
        }
    }

    async sendpost(url,data){
        try{
            let rs = await this.post(url,data);
            return rs;
        }
        catch(e){
            console.log(e)
            return false;
        }
    }

    testname = 'hello group'
    i=1
    message(){
        this.i++
    }


}

export default new Group();

/**
 * //导出工具类 export default Group;
 *
 * //使用vuex进行状态管理的方式调用, 适用于需要在多组件间共享数据的情况
 *
 * //导入 import Group from '../../../../service/Group' let GroupModule ={ state: {
 * object: new Group() }, mutations: { increment (state) { state.count++ } },
 * actions: {
 *  } }
 *
 * ... , beforeCreate(){//注册 this.$store.registerModule('Group', GroupModule) },
 * methods:{ test(){
 * this.$store.state.Group.object.message() }, ...
 *
 */